import Generate from './fake_generator'

let id = 1
const maps = {
  add (payload) {
    const data = {
      id: id++,
      name: payload.name,
      pictureSize: payload.imageSize,
      picture: payload.picture,
      center: payload.center,
    }
    this.list.push(data)

    return data
  },
  list: [],
}

maps.add({ name: 'My garden', imageSize: [794, 1123], picture: 'pic.svg', center: [397, 561.5] })
maps.add({ name: 'My OSM garden', imageSize: null, picture: null, center: [11310.901110285376, 6120574.625712863] })
export default Generate('Maps', maps, ['load', 'add'])
